<template>
    <van-search v-model="searchValue" show-action shape="round" placeholder="输入搜索关键词" @clear="onClear">
        <template #action>
            <div @click="onSearch">搜索</div>
        </template>
    </van-search>
</template>
<script>
export default {
    name: 'search-box',
    data() {
        return {
            searchValue: '',
            ready: false,
        };
    },
    watch: {
        '$route.query.search': {
            handler(v) {
                this.searchValue = v
            },
            immediate: true,
        },
        searchValue: {
            handler(v) {
                if (v == '') {
                    this.$emit('onChange', v)
                }
                this.ready = true
            },
            immediate: true,
        },
        value: {
            handler(v) {
                if (v != '' && !this.ready) {
                    this.searchValue = v
                }
            },
            immediate: true,
        },
    },
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClear() {
            this.searchValue = '';
        },
        onSearch() {
            if (this.searchValue == null || this.searchValue.trim() == '') {
                this.$toast.fail('搜索内容不能为空哦~')
                return;
            }

            if (this.$route.path.indexOf('category/product') >= 0) {
                this.$emit('onChange', this.searchValue)
            }
            else {
                this.$router.push({
                    path: '/category/product',
                    query: {
                        search: this.searchValue
                    }
                })
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Search/index.vue